import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const JobPostingList = Loadable(
  lazy(() => import("features/jobPosting/components/List"))
);

const routes = {
  path: "jobPosting",
  children: [{ path: "", element: <JobPostingList /> }],
};

export default routes;
